/* Style4Him - Kachelfarben. Ausgelagert am 12.09. aus
   snippets/s4h-kachelfarben-skript.liquid. Grund: die Section
   s4h-products steht mehrfach je Seite und schrieb dieses
   Skript jedes Mal komplett ins HTML.

   Unveraendert gegenueber der Inline-Fassung: der Schalter
   window.s4hKachelfarbe, alle drei Funktionen und beide
   Zuhoerer. Die Zuhoerer sitzen weiterhin am document, nicht an
   der Kachel - das Skript greift beim Start auf KEIN einziges
   Element im DOM zu und arbeitet deshalb auch dann korrekt,
   wenn es erst nach dem Aufbau der Seite startet.

   Neu ist nur die readyState-Weiche am Ende: laeuft die Seite
   noch, wird auf DOMContentLoaded gewartet, sonst geht es sofort
   los. Damit haengen die Zuhoerer in jedem Fall genau einmal -
   egal ob die Datei normal, mit defer oder nachtraeglich
   eingebunden wird. */

(function () {
  if (window.s4hKachelfarbe) return;
  window.s4hKachelfarbe = true;

  var STANDARDKNOPF = 'In den Warenkorb';

  function suche(ziel, wahl) {
    return ziel && ziel.closest ? ziel.closest(wahl) : null;
  }

  /* Beim Drueberfahren wird das Bild schon geholt. Bis der Klick
     kommt, liegt es im Zwischenspeicher und die Vorschau steht
     sofort da - ohne Ladepause und ohne leeres Feld. */
  function vorladen(knopf) {
    if (knopf.dataset.vorgeladen === '1' || !knopf.dataset.bild) return;
    knopf.dataset.vorgeladen = '1';
    var p = new Image();
    if (knopf.dataset.satz) p.srcset = knopf.dataset.satz;
    p.src = knopf.dataset.bild;
  }

  function waehlen(knopf) {
    var karte = knopf.closest('.s4h-p');
    if (!karte) return;

    var alle = knopf.parentNode.querySelectorAll('.s4h-p__swb');
    for (var i = 0; i < alle.length; i++) {
      alle[i].setAttribute('aria-pressed', alle[i] === knopf ? 'true' : 'false');
    }

    var name = karte.querySelector('.s4h-p__swname');
    if (name && knopf.dataset.farbe) name.textContent = knopf.dataset.farbe;

    var kasten = karte.querySelector('.s4h-p__vorschau');
    var medien = karte.querySelector('.s4h-p__media');
    if (kasten && medien && knopf.dataset.bild) {
      var bild = kasten.querySelector('img');
      if (bild) {
        var breite = Math.round(medien.getBoundingClientRect().width);
        if (breite > 40) bild.sizes = breite + 'px';
        bild.alt = knopf.dataset.farbe || '';
        if (knopf.dataset.satz) bild.srcset = knopf.dataset.satz;
        bild.src = knopf.dataset.bild;
      }
      if (knopf.dataset.ziel) kasten.href = knopf.dataset.ziel;
      kasten.removeAttribute('aria-hidden');
      kasten.removeAttribute('tabindex');
      karte.setAttribute('data-farbwahl', '1');
    }

    /* Der Produktlink muss die gewaehlte Farbe mitnehmen. Sonst
       steht der Kunde auf der Produktseite wieder vor der
       Standardfarbe und muss ein zweites Mal waehlen. */
    if (knopf.dataset.ziel) {
      var titel = karte.querySelector('.s4h-p__name');
      if (titel) titel.href = knopf.dataset.ziel;
    }

    /* Warenkorb auf die Variante umstellen. Ausverkaufte Farbe
       schaltet den Knopf ab - sonst legt der Kunde ungewollt die
       Standardfarbe in den Warenkorb. */
    var feld = karte.querySelector('.s4h-p__add input[name="id"]');
    var kknopf = karte.querySelector('.s4h-p__add button');
    if (feld && knopf.dataset.variante) feld.value = knopf.dataset.variante;
    if (kknopf) {
      if (knopf.dataset.frei === '0') {
        kknopf.disabled = true;
        kknopf.textContent = 'Ausverkauft';
      } else if (feld) {
        kknopf.disabled = false;
        kknopf.textContent = STANDARDKNOPF;
      }
    }
  }

  function start() {
    document.addEventListener('pointerover', function (e) {
      var knopf = suche(e.target, '.s4h-p__swb');
      if (knopf) vorladen(knopf);
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var knopf = suche(e.target, '.s4h-p__swb');
      if (knopf) {
        e.preventDefault();
        vorladen(knopf);
        waehlen(knopf);
        return;
      }
      /* Wer die Pfeile benutzt, will wieder durch alle Bilder
         blaettern - dann muss die Farbvorschau weichen. */
      var pfeil = suche(e.target, '.s4h-p__nav');
      if (pfeil) {
        var karte = pfeil.closest('.s4h-p');
        if (karte) karte.removeAttribute('data-farbwahl');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* 10.10.2026: Lader fuer den Umschalter Produkt|Getragen (assets/s4h-ansicht.js).
   Zuruecknehmen: diese Zeile loeschen. Bei Aenderung an s4h-ansicht.js ?v= hochzaehlen
   (das CDN haelt sonst die alte Fassung fest). 12.10.: v=10 (Handy-Zeile Filter + Schalter, kleinere Ueberschrift). */
(function(){try{var s=document.currentScript;if(!s||window.s4hAnsichtGeladen)return;window.s4hAnsichtGeladen=1;var u=s.src.replace(/s4h-kachelfarben\.js[^?]*(\?.*)?$/,'s4h-ansicht.js?v=10');var e=document.createElement('script');e.src=u;e.defer=true;document.head.appendChild(e);}catch(x){}})();
